import React from 'react';
import Table from '../Table/Table';
import style from './InstitutionalSentiment.module.css';

const InstitutionalSentiment = ({ data }) => {
  if (!data) {
    return (
      <div>
        <h3 className={style.headline}>Institutional Sentiment (Put/Call)</h3>
        <p className={style.noData}>No data available for the latest quarter.</p>
      </div>
    );
  }

  const formatNumber = (num) => {
    if (!num) return '-';
    return new Intl.NumberFormat('en-US').format(num);
  };

  const renderChange = (value) => {
    if (value === null || value === undefined || isNaN(value)) return null;
    const num = parseFloat(value);
    if (isNaN(num)) return null;
    
    if (num === 0) return <span className={style.change}>0%</span>;
    const isPositive = num > 0;
    return (
      <span className={`${style.change} ${isPositive ? style.positive : style.negative}`}>
        {isPositive ? '▲' : '▼'} {Math.abs(num).toFixed(2)}%
      </span>
    );
  };

  const ratio = parseFloat(data.put_call_ratio);
  let reading = 'Below 1 means more calls than puts. Above 1 means more puts, a more cautious stance.';
  if (Number.isFinite(ratio)) {
    const shown = ratio.toFixed(2);
    if (ratio < 0.98) {
      reading = `At ${shown}, the ratio is below 1, so institutions hold more calls than puts.`;
    } else if (ratio > 1.02) {
      reading = `At ${shown}, the ratio is above 1, so institutions hold more puts than calls. That is a more cautious stance.`;
    } else {
      reading = `At ${shown}, calls and puts are about even.`;
    }
  }

  return (
    <div>
      <h3 className={style.headline}>Institutional Put/Call Ratio</h3>
      <p className={style.text}>
        Compares institutional put options with call options. {reading}
      </p>
      
      <Table>
        <tbody>
          <tr>
            <th>Put/Call Ratio</th>
            <td className={style.value}>
              <span className={style.highlight}>{parseFloat(data.put_call_ratio).toFixed(4)}</span>
              {renderChange(data.put_call_ratio_change)}
            </td>
          </tr>
          <tr>
            <th>Total Calls</th>
            <td className={style.value}>
              {formatNumber(data.total_calls)}
              {renderChange((data.total_calls_change / data.last_total_calls) * 100)}
            </td>
          </tr>
          <tr>
            <th>Total Puts</th>
            <td className={style.value}>
              {formatNumber(data.total_puts)}
              {renderChange((data.total_puts_change / data.last_total_puts) * 100)}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default InstitutionalSentiment;

